import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, apiErr } from "../lib/api";
import { BrandLogo } from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex flex-col">
      <div className="max-w-6xl mx-auto w-full px-4 h-16 flex items-center">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white" data-testid="forgot-back"><ArrowLeft size={16} /> Torna al portale</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
          <div className="mb-6"><BrandLogo name="Pickfood" size={30} /></div>
          {sent ? (
            <div data-testid="forgot-sent">
              <div className="w-12 h-12 rounded-full bg-[#FFC400]/20 grid place-items-center text-[#FFC400] mb-4"><MailCheck size={24} /></div>
              <h1 className="font-head text-2xl font-bold">Controlla la tua email</h1>
              <p className="text-white/60 text-sm mt-2">Se esiste un account per <b className="text-white">{email}</b>, ti abbiamo inviato un link per reimpostare la password. Scade tra 1 ora.</p>
              <Link to="/account/login" className="inline-block mt-6 text-[#FFC400] font-semibold hover:underline">Torna all'accesso →</Link>
            </div>
          ) : (
            <>
              <h1 className="font-head text-2xl font-bold">Password dimenticata?</h1>
              <p className="text-white/55 text-sm mb-6">Inserisci la tua email: ti invieremo un link per crearne una nuova.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="email" className="text-white/80">Email</Label>
                  <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"
                    className="h-11 mt-1 bg-white/5 border-white/10 text-white placeholder:text-white/35" placeholder="nome@esempio.it" />
                </div>
                <Button type="submit" disabled={busy} data-testid="forgot-submit"
                  className="w-full h-11 bg-[#FFC400] hover:bg-[#E6AC00] text-[#0B0B0D] rounded-full text-base font-semibold">
                  {busy ? <Loader2 className="animate-spin" /> : "Invia link di reset"}
                </Button>
              </form>
              <p className="text-xs text-white/40 mt-5 text-center">
                <Link to="/account/login" className="text-[#FFC400] hover:underline">Accesso clienti</Link>
                {" · "}
                <Link to="/esercenti/login" className="text-[#FFC400] hover:underline">Accesso partner</Link>
              </p>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
}
